import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Header, Loader, Menu, Segment, Container, Grid } from "semantic-ui-react";
import { Route, Switch, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { login, logout } from "../../modules/auth";
import { ACCOUNT_APP_LOGIN, ACCOUNT_APP_SIGNUP, redirectToAccountApp } from "../../modules/accountApp";

class NewHeader extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
      }).isRequired,
      staticContext: PropTypes.object,
    }).isRequired,
  };

  render() {
    const { history } = this.context.router;

    const newHomeLink = () => history.push("/");
    const newDashboardLink = () => history.push("/dashboard");
    const newloginLink = () => redirectToAccountApp(ACCOUNT_APP_LOGIN);
    const newsignupLink = () => redirectToAccountApp(ACCOUNT_APP_SIGNUP);

    const unauthenticatedMenu = (
      <Menu.Menu position="right">
        <Menu.Item className="log-in-button" onClick={newloginLink}>
          Log in
        </Menu.Item>
        <Menu.Item className="sign-up-button" fitted>
          <Button color="green" onClick={newsignupLink} className="new-branding-button">
            Sign up
          </Button>
        </Menu.Item>
      </Menu.Menu>
    );

    const authenticatedMenu = () => (
      <Menu.Menu position="right">
        <Menu.Item className="log-out-button" name="logout" onClick={this.props.logout}>
          Logout
        </Menu.Item>
        <Dropdown item icon="content">
          <Dropdown.Menu>
            <Dropdown.Item onClick={newDashboardLink}>My dashboard</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    );

    return (
      <Menu size="massive" borderless color="blue" inverted attached="top" className="new-branding-header">
        <Menu.Item header onClick={newHomeLink} style={{ paddingRight: "unset" }}>
          <div>
            <img className="primary-logo" src="images/new-branding-hozah-white.png" alt="Hozah Autopay" />
          </div>
        </Menu.Item>
        {this.props.isAuthenticated ? authenticatedMenu() : unauthenticatedMenu}
      </Menu>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  initialising: state.auth.initialising,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      logout,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewHeader);
